import { FormGroup, type AbstractControl, type ValidationErrors } from '@angular/forms';
import { checkPasswordStrength } from '@sharedlib/common/utils/password-strength';
import { isValidUsername } from '@sharedlib/common/utils/username-validation';

export namespace FormValidators {
  export function username(control: AbstractControl): ValidationErrors | null {
    const value = control.value;
    if (!value) return null;
    return isValidUsername(value) ? null : { username: true };
  }

  export function weakPassword(control: AbstractControl<string>): ValidationErrors | null {
    return checkPasswordStrength(control.value);
  }

  /** A whole number. Empty is left to `required`; a fraction such as 1.5 is refused, as the server's `@IsInt()` would. */
  export function integer(control: AbstractControl<number | null | undefined>): ValidationErrors | null {
    const value = control.value;
    if (value === null || value === undefined || (typeof value === 'string' && value === '')) return null;
    return Number.isInteger(Number(value)) ? null : { integer: true };
  }

  export function passwordConfirmation(controlName: string, matchingControlName: string) {
    return (form: FormGroup) => {
      if (form.controls[controlName].value !== form.controls[matchingControlName].value) {
        form.controls[matchingControlName].setErrors({ notEqual: true });
      } else if (form.controls[matchingControlName].errors?.notEqual) {
        delete form.controls[matchingControlName].errors.notEqual;
        form.controls[matchingControlName].updateValueAndValidity();
      }
      return null;
    };
  }
}
